import { action } from "effection";
export function createBatchMdw(queue) {
    let notifying = false;
    return function* batchMdw(_, next) {
        if (!notifying) {
            notifying = true;
            yield* action(function* (resolve) {
                queue(() => {
                    notifying = false;
                    resolve();
                });
            });
            yield* next();
        }
    };
}
